import { Link } from "react-router-dom";
import { Facebook, Mail, MapPin, Phone } from "lucide-react";

function Footer() {
    return (
        <footer className="bg-[#33367b] text-white font-Inter">
            <div className="mx-auto max-w-[1340px] px-4 py-16 sm:px-6 lg:px-8">
                {/* Logo & Mạng Xã Hội */}
                <div className="flex flex-col items-center sm:flex-row sm:justify-between">
                    <div className="flex items-center space-x-4 pb-6">
                        <img src="/assets/images/header/timo1.png" alt="Company Logo" className="h-12" />

                    </div>

                    <div className="flex space-x-6 mt-4 mb-4 sm:mt-0">
                        <Link to="https://www.facebook.com/profile.php?id=61557369250062" className="hover:opacity-75">
                            <Facebook className="h-6 w-6" />
                        </Link>
                        {/*<Link to="/" className="hover:opacity-75">*/}
                        {/*    <Mail className="h-6 w-6" />*/}
                        {/*</Link>*/}
                    </div>
                </div>

                {/* Dịch vụ & Thông tin liên hệ */}
                <div className="grid grid-cols-1 gap-8 border-t border-gray-200 pt-8 sm:grid-cols-2 lg:grid-cols-4">
                    <div>
                        <h3 className="font-medium text-lg">Công ty</h3>
                        <ul className="mt-4 space-y-3 text-sm">
                            <li><Link to="/about" className="text-gray-300 hover:opacity-75">Về Timo</Link></li>
                            <li><Link to="/products" className="text-gray-300 hover:opacity-75">Sản phẩm</Link></li>
                            <li><Link to="/news" className="text-gray-300 hover:opacity-75">Blog</Link></li>
                            <li><Link to="/wishlist" className="text-gray-300 hover:opacity-75">Liên hệ</Link></li>
                        </ul>
                    </div>

                    <div>
                        <h3 className="font-medium text-lg">Chính sách</h3>
                        <ul className="mt-4 space-y-3 text-sm">

                            <li><Link to="/" className="text-gray-300 hover:opacity-75">Chính sách bảo mật</Link></li>
                            <li><Link to="/" className="text-gray-300 hover:opacity-75">Điều khoản sử dụng</Link></li>
                            <li><Link to="/" className="text-gray-300 hover:opacity-75">Hỗ trợ khách hàng</Link></li>
                        </ul>
                    </div>

                    <div>
                        <h3 className="font-medium text-lg">Thông tin liên hệ</h3>
                        <ul className="mt-4 space-y-3 text-sm">
                            <li className="flex items-center space-x-2">
                                <Phone className="h-4 w-4" />
                                <span>+84 862 257 632</span>
                            </li>
                            {/*<li className="flex items-center space-x-2">*/}
                            {/*    <Mail className="h-4 w-4" />*/}
                            {/*    <span>contact@timofabrics.com</span>*/}
                            {/*</li>*/}
                            <li className="flex items-center space-x-2">
                                <MapPin className="h-4 w-4" />
                                <span>Khu TM Baza A30, sau chợ Baza, gần sân chơi Nam Hồng.</span>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Bản quyền */}
                <p className="text-center text-xs text-gray-400 mt-12">
                    &copy; {new Date().getFullYear()} VaithethaoTimo. All rights reserved.
                </p>
            </div>
        </footer>
    );
}

export default Footer;
